import type {
  CreateDivisionRequestDto,
  DivisionDto,
  GetDivisionsResponseDto,
  RemoveDivisionResponseDto,
  UpdateDivisionRequestDto,
} from 'shared/dtos/divisions.dto';

import { ApiService } from './api.service';

export default class DivisionsService extends ApiService {
  public getDivisions = async (): Promise<GetDivisionsResponseDto> => {
    return await this.get(`/divisions`);
  };

  public getDivision = async (id: number): Promise<DivisionDto> => {
    return await this.get(`/divisions/${id}`);
  };

  public removeDivision = async (
    id: number,
  ): Promise<RemoveDivisionResponseDto> => {
    return await this.remove(`/divisions/${id}`);
  };

  public createDivision = async (
    formData: CreateDivisionRequestDto,
  ): Promise<DivisionDto> => {
    const requestBody = {
      id: null,
      title: formData.title,
      missions: formData.missions,
      environments: formData.environments,
      PeopleId: formData.PeopleId,
      AgencyId: formData.AgencyId,
      Activities: formData.Activities,
      ShortTermGoals: formData.ShortTermGoals,
    };

    return await this.post('/divisions', requestBody);
  };

  public updateDivision = async (
    id: number,
    formData: UpdateDivisionRequestDto,
  ): Promise<DivisionDto> => {
    const requestBody = {
      title: formData.title,
      missions: formData.missions,
      environments: formData.environments,
      PeopleId: formData.PeopleId,
      AgencyId: formData.AgencyId,
      Activities: formData.Activities,
      ShortTermGoals: formData.ShortTermGoals,
    };

    return await this.put(`/divisions/${id}`, requestBody);
  };
}
